import React, { useState } from "react";
import PropTypes from "prop-types";
import { Typography, Box, TextField, InputAdornment } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { useDebouncedValue } from "../hooks/useDebouncedValue";
import { LocationTree } from "./LocationTree";
import { useStyles } from "./location-tree-sidebar.style";

const DEFAULT_DEBOUNCE_MS = 500;

export function LocationTreeSidebar({
  title,
  search: controlledSearch,
  onSearchChange,
  debounceMs = DEFAULT_DEBOUNCE_MS,
  searchPlaceholder = "Search locations...",
  locations,
  mode,
  selected,
  onSelect,
  checked,
  onCheck,
  expanded,
  onToggle,
}) {
  const classes = useStyles();
  const isControlled = controlledSearch !== undefined && typeof onSearchChange === "function";
  const [internalSearch, setInternalSearch] = useState("");
  const searchInput = isControlled ? controlledSearch : internalSearch;
  const debouncedSearch = useDebouncedValue(searchInput, debounceMs);

  const handleSearchChange = (event) => {
    const next = event.target.value;
    if (isControlled) onSearchChange(next);
    else setInternalSearch(next);
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.sidebarHeader}>
        {title != null && title !== "" && (
          <Typography className={classes.sidebarTitle}>{title}</Typography>
        )}
        <TextField
          placeholder={searchPlaceholder}
          value={searchInput}
          onChange={handleSearchChange}
          fullWidth
          variant="outlined"
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Box className={classes.treeContainer}>
        <LocationTree
          locations={locations}
          search={debouncedSearch}
          selected={selected}
          onSelect={onSelect}
          mode={mode}
          checked={checked}
          onCheck={onCheck}
          expanded={expanded}
          onToggle={onToggle}
        />
      </Box>
    </Box>
  );
}

LocationTreeSidebar.propTypes = {
  title: PropTypes.string,
  search: PropTypes.string,
  onSearchChange: PropTypes.func,
  debounceMs: PropTypes.number,
  searchPlaceholder: PropTypes.string,
  locations: PropTypes.array.isRequired,
  mode: PropTypes.string,
  selected: PropTypes.string,
  onSelect: PropTypes.func,
  checked: PropTypes.instanceOf(Set),
  onCheck: PropTypes.func,
  expanded: PropTypes.instanceOf(Set),
  onToggle: PropTypes.func,
};

LocationTreeSidebar.defaultProps = {
  title: undefined,
  search: undefined,
  onSearchChange: undefined,
  debounceMs: DEFAULT_DEBOUNCE_MS,
  searchPlaceholder: "Search locations...",
  mode: "browse",
  selected: undefined,
  onSelect: undefined,
  checked: undefined,
  onCheck: undefined,
  expanded: undefined,
  onToggle: undefined,
};
